import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  abbreviation: {
    required,
  },
  countryId: {
    required,
  },
  unit: {
    required,
  },
  symbol: {
    required,
  },
};
export default validations;